import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['sugargoo-shipping-cost'];
  return <ArticleLayout article={article} />;
}